// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.applications-row[data-v-4f4b29f0] {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 30px;\n  margin: 0 auto;\n}\n.applications-row-2-columns[data-v-4f4b29f0] {\n  width: 680px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
